

module.exports = __webpack_require__.stylable.create(
    "TabsNavButton522433319",
    {"classes":{"root":"TabsNavButton522433319__root","border":"TabsNavButton522433319__border"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "TabsNavButton522433319",
    null
);
